import css from "styled-jsx/css";

export const productFeaturesTableFeature = css`
  .feature-name {
    justify-content: space-between;
    font-weight: 400;
    font-size: 15px;
    .icon {
      position: relative;
      margin-left: 6px;
      .tooltip {
        position: relative;
        bottom: 60px;
        display: flex;
        justify-content: center;
        left: -50%;
        visibility: hidden;
      }
      &:hover {
        .tooltip {
          visibility: visible;
        }
      }
    }
  }
  .feature-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    color: #676879;
  }
  .feature-value {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 16px 0;
  }

  .check-circle {
    :global(path) {
      fill: #676879;
    }
  }
`;
